<template>
  <div :class="['vuetable-pagination-info']" v-html="paginationInfo">
  </div>
</template>

<script>
  import PaginationInfoMixin from 'Components/vuetable-2/VuetablePaginationInfoMixin.vue'

  export default {
    mixins: [PaginationInfoMixin],
  }
</script>
